<div *ngIf="rendered" class="tw-fixed tw-inset-0 tw-z-[5000] tw-flex tw-items-end tw-justify-center">
	<!-- Backdrop -->
	<div
		class="tw-absolute tw-inset-0 tw-bg-slate-900/40 tw-backdrop-blur-md tw-transition-opacity tw-duration-300"
		[class.tw-opacity-100]="opened"
		[class.tw-opacity-0]="!opened"
		(click)="onClose()"
		aria-hidden="true"
	></div>

	<!-- Bottom Sheet -->
	<div
		class="drawer tw-relative tw-w-full tw-max-w-screen-2xl tw-bg-slate-50 tw-shadow-[0_-20px_60px_-15px_rgba(0,0,0,0.3)] tw-z-[5001] tw-flex tw-flex-col tw-overflow-hidden"
		[class.drawer--open]="opened"
		role="dialog"
		aria-modal="true"
	>
		<!-- Drawer Handle -->
		<div class="tw-absolute tw-top-3 tw-left-1/2 tw--translate-x-1/2 tw-w-16 tw-h-1.5 tw-bg-slate-200 tw-rounded-full tw-z-[80]"></div>

		<!-- Shared Header Section: 3 columns (student | center slot | actions) -->
		<header
			class="tw-relative tw-z-20 tw-bg-white tw-grid tw-items-center tw-gap-x-2 sm:tw-gap-x-3 md:tw-gap-x-4 tw-px-4 sm:tw-px-6 md:tw-px-8 tw-pt-5 sm:tw-pt-6 tw-pb-3 tw-border-b tw-border-slate-100 tw-shrink-0 tw-overflow-hidden tw-rounded-t-[3.5rem]"
			[ngClass]="showHeaderCenter
				? 'tw-grid-cols-[minmax(0,1fr)_minmax(0,9rem)_auto] sm:tw-grid-cols-[minmax(0,1fr)_minmax(0,11rem)_auto] md:tw-grid-cols-[minmax(0,1.2fr)_minmax(0,14rem)_auto] lg:tw-grid-cols-[minmax(0,1.5fr)_minmax(0,16rem)_auto]'
				: 'tw-grid-cols-[minmax(0,1fr)_auto]'"
		>
			<div class="tw-relative tw-z-30 tw-flex tw-items-start tw-gap-2 sm:tw-gap-3 lg:tw-gap-4 tw-min-w-0 tw-justify-self-start tw-col-start-1 tw-row-start-1 tw-overflow-hidden">
				<div class="tw-shrink-0 tw-mt-0.5" *ngIf="student != null">
					<app-para-student-badge
						class="tw-w-11 tw-h-11"
						[student]="student"
						[milestoneOverlay]="studentBadgeMilestoneOverlay"
					></app-para-student-badge>
				</div>

				<div class="tw-min-w-0 tw-flex-1 tw-flex tw-flex-col tw-gap-2">
					<div class="tw-flex tw-items-baseline tw-gap-2 tw-min-w-0">
						<h2
							data-para-redact
							class="tw-m-0 tw-text-slate-900 tw-text-xl tw-font-black tw-leading-tight tw-truncate"
						>
							{{ resolvedStudentName }}
						</h2>
						<span
							*ngIf="resolvedStudentGrade"
							class="tw-shrink-0 tw-text-slate-500 tw-text-xs tw-font-semibold tw-leading-tight"
						>Grade {{ resolvedStudentGrade }}</span>
					</div>
					<ng-content select="[headerLeft]"></ng-content>
					<ng-content select="[headerSupplement]"></ng-content>
				</div>
			</div>

			<div
				*ngIf="showHeaderCenter"
				class="tw-col-start-2 tw-row-start-1 tw-flex tw-items-center tw-justify-center tw-min-w-0 tw-px-1 sm:tw-px-2 tw-overflow-hidden tw-z-20"
			>
				<ng-content select="[headerCenter]"></ng-content>
			</div>

			<div
				class="tw-relative tw-z-30 tw-flex tw-items-center tw-gap-2 sm:tw-gap-3 tw-shrink-0 tw-justify-self-end tw-row-start-1"
				[class.tw-col-start-3]="showHeaderCenter"
				[class.tw-col-start-2]="!showHeaderCenter"
			>
				<ng-content select="[headerActions]"></ng-content>

				<div class="tw-w-px tw-h-7 tw-bg-slate-100 tw-shrink-0"></div>

				<button
					type="button"
					class="tw-w-10 tw-h-10 tw-flex tw-items-center tw-justify-center tw-text-slate-400 hover:tw-text-slate-900 hover:tw-bg-slate-50 tw-text-2xl tw-leading-none tw-bg-transparent tw-border-0 tw-rounded-xl tw-cursor-pointer tw-transition-all active:tw-scale-95 tw-shrink-0"
					aria-label="Close"
					(click)="onClose()"
				>
					&times;
				</button>
			</div>
		</header>

		<!-- Sub-header slot (e.g., tab bar, scoring guide panel) -->
		<div class="tw-relative tw-z-[60] tw-shrink-0 tw-overflow-visible">
			<ng-content select="[subHeader]"></ng-content>
		</div>

		<!-- Main Content Body -->
		<div class="tw-relative tw-z-0 tw-flex-1 tw-min-h-0 tw-overflow-hidden tw-flex tw-flex-col">
			<ng-content></ng-content>
		</div>

		<!-- Footer slot -->
		<ng-content select="[footer]"></ng-content>
	</div>
</div>
